import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Post } from '../services/http';
import { validateForm } from '../services/validate';
import UploadImage from '../services/upload-image';
import './dialog.css';

export default function VideoPop(props) {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState(null);
    const [partnerLink, setPartnerLink] = React.useState(null);
    const openInfoPopup = useStoreActions((actions) => actions.open);
    const config = useStoreState((state) => state.config);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>
            <div className="" onClick={handleClickOpen}>
                {/* <div style={{ marginTop: '18px' }}>
                    <button type="submit" style={{ display: 'flex', padding: '6px' }} className="login_button"><span style={{ display: 'inline-block', paddingLeft: '5px', paddingRight: '5px' }}>Video Popup</span></button>
                </div> */}
                {props.image}
            </div>
            <div id="popup-login" className={open ? 'popupmain _open' : 'popupmain'}>
                <div class="popup__body">
                    <div class="">
                        <div class="login-form" style={{ position: 'relative' }}>
                            <p class="remove-margin-bottom" onClick={handleClose} style={{ cursor: 'pointer', color: 'red', position: 'absolute', top: '5%', right: '5%' }}><CloseIcon style={{ fontSize: '30px' }} /></p>
                            {/* <div class="center-text-and-line"> */}
                            <div class="form-button videopopo">
                               {/* <img src="/img/videoImage.jpeg" style={{ width: '100%' }} alt=""/> */}
                               <iframe width="100%" height="100%" src="https://www.youtube.com/embed/ayQCXH25uDs" title="YouTube video player" frameborder="0" 
                               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen="false"></iframe>
                            </div>
                            {/* </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
